/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{bufferBuf82B64 as r,haveBufferBase64 as t}from"../utils/buffer.js";import{getArrayBuffer as e,ab2b64 as n}from"./arraybuffer.js";export const getUint8Array=(r,t=0,e=-1,n=!1)=>{const s=-1===e?r.byteLength-t:e;if(r instanceof ArrayBuffer){if(n){const e=r.slice(t,t+s);return new Uint8Array(e)}return new Uint8Array(r,t,s)}return n?r.slice(t,s+t):new Uint8Array(r.buffer,t+r.byteOffset,s)};export const clearHexInput=r=>{const t=!r.startsWith("0x"),e=r.length%2==0;return t&&e?r:t?`0${r}`:e?r.substring(2):`0${r.substring(2)}`};export const pureBuf82B64=r=>n(e(r));export const buf82b64=t()?r:pureBuf82B64;